/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slow_Early_Liger_SpurInputs */

const fr_slow_early_liger_spur = /** @type {(inputs: Slow_Early_Liger_SpurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun enregistrement trouvé`)
};

/**

* @param {Slow_Early_Liger_SpurInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const slow_early_liger_spur = /** @type {((inputs?: Slow_Early_Liger_SpurInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slow_Early_Liger_SpurInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_slow_early_liger_spur(inputs)
});